import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

export type StorageUnit = "PB" | "TB" | "GB";

export interface UnitToggleProps {
  units: StorageUnit[];
  baseUnit: StorageUnit;
  precision?: number;
  si?: boolean; // true = 1000, false = 1024
  onUnitChange?: (unit: StorageUnit) => void;
}

export default function UnitToggle({
  units,
  baseUnit,
  precision = 2,
  si = false,
  onUnitChange,
}: UnitToggleProps) {
  const STORAGE_KEY = 'dashboard-unit';
  const [selected, setSelected] = useState<StorageUnit>(baseUnit);

  // load from localStorage
  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY) as StorageUnit;
    if (saved && units.includes(saved)) {
      setSelected(saved);
      onUnitChange?.(saved);
    }
  }, []);

  const handleChange = (unit: StorageUnit) => {
    setSelected(unit);
    localStorage.setItem(STORAGE_KEY, unit);
    onUnitChange?.(unit);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #5A97BF',
        borderRadius: '20px',
        overflow: 'hidden',
      }}
    >
      {units.map((u, index) => {
        const isSelected = selected === u;

        return (
          <Box
            key={u}
            onClick={() => handleChange(u)}
            sx={{
              px: 0.3,
              py: 0.5,
              cursor: 'pointer',
            //   fontSize: 12,
            //   fontWeight: 600,
              minWidth: 40,
              textAlign: 'center',
              userSelect: 'none',
              backgroundColor: isSelected ? '#12386D' : 'transparent',
              color: isSelected ? '#fff' : '#5A97BF',
              transition: 'all 0.2s ease',
              borderLeft: index !== 0 ? '1px solid #5A97BF' : 'none', // left border for middle/right
            }}
          >
            <Typography variant='bodyText'>{u}</Typography>
          </Box>
        );
      })}
    </Box>
  );
}
